// tslint:disable:max-line-length

import React from 'react';

export const ChartBulletOutline = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <rect y="15" width="16" height="1" />
      <path d="M6.5,7 M7.5,6h-6v8h6V6L7.5,6z M3.5,9h2v5h-2V9z" />
      <path d="M14.5,1.5h-6V14h6V1.5L14.5,1.5z M10.5,6h2v8h-2V6z" />
    </svg>
  );
};
